// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"coming-soon_comingSoon__3hUZ0","automation":"coming-soon_automation__erWPk","funnel":"coming-soon_funnel__1Me-I"};